<div class="profile-icon" [ngStyle]="{ 'background-image': imageUrl ? 'url(' + imageUrl + ')' : 'none' }">
  <ng-container *ngIf="userShortName && userShortName !=''">
    <mat-icon>{{ userShortName }}</mat-icon>
  </ng-container>
</div>
